import React from 'react';
import { Cloud, Database, ShieldCheck, GraduationCap } from 'lucide-react';
import { motion } from 'framer-motion';

const services = [
    {
        icon: <Database className="w-12 h-12 text-gray-900 dark:text-white" />,
        title: "データ活用システムアーキテクチャ",
        description: "データ活用のためのシステムアーキテクチャー検討支援。最適なデータフローと基盤構成を設計します。",
        note: { text: "データ活用を促進するツールづくりのnote記事はこちら", url: "https://note.com/pjnexus/n/n4f266d39aa5d" }
    },
    {
        icon: <Cloud className="w-12 h-12 text-gray-900 dark:text-white" />,
        title: "クラウドエンジニアリング",
        description: "Azure / AWS / GCP 利用のための環境設計、設定支援。マルチクラウド・ハイブリッドクラウドにも対応。"
    },
    {
        icon: <ShieldCheck className="w-12 h-12 text-gray-900 dark:text-white" />,
        title: "IdP統合・認証基盤",
        description: "IdPの整理・統合・高度化に関する支援。セキュリティと利便性を両立する認証基盤を構築します。"
    },
    {
        icon: <GraduationCap className="w-12 h-12 text-gray-900 dark:text-white" />,
        title: "人材育成・教育",
        description: "上記に関わるIT人材育成・教育サービス。組織の技術力向上をバックアップします。",
        note: { text: "マネージャー向けnote記事執筆も行っています。", url: "https://note.com/pjnexus" }
    }
];

const Services = () => {
    return (
        <section id="services" className="py-20 bg-white dark:bg-gray-800 transition-colors duration-300 scroll-mt-16">
            <div className="container mx-auto px-4 md:px-6">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">専門性・支援領域</h2>
                    <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
                        ご相談の内容に応じて、クラウド・データ活用・認証基盤の設計から実装支援、人材育成まで対応します。
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {services.map((service, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className="p-6 bg-gray-50 dark:bg-gray-700 rounded-xl hover:shadow-xl transition-shadow duration-300 border border-gray-100 dark:border-gray-600"
                        >
                            <div className="mb-4">{service.icon}</div>
                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">{service.title}</h3>
                            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
                                {service.description}
                            </p>
                            {service.note && (
                                <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mt-2">
                                    <a
                                        href={service.note.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="underline hover:text-gray-900 dark:hover:text-white transition-colors"
                                    >
                                        {service.note.text}
                                    </a>
                                </p>
                            )}
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
